module.exports = __webpack_public_path__ + "assets/img/report-data-bg-2.195c92e4.png";